import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// English translations
import enAuth from "./locales/en/auth.json";
import enForm from "./locales/en/form.json";
import enValidation from "./locales/en/validation.json";
import enApplication from "./locales/en/application.json";
import enCommon from "./locales/en/common.json";
import enPdpa from "./locales/en/pdpa.json";

// Thai translations
import thAuth from "./locales/th/auth.json";
import thForm from "./locales/th/form.json";
import thValidation from "./locales/th/validation.json";
import thApplication from "./locales/th/application.json";
import thCommon from "./locales/th/common.json";
import thPdpa from "./locales/th/pdpa.json";

const resources = {
  en: {
    auth: enAuth,
    form: enForm,
    validation: enValidation,
    application: enApplication,
    common: enCommon,
    pdpa: enPdpa,
  },
  th: {
    auth: thAuth,
    form: thForm,
    validation: thValidation,
    application: thApplication,
    common: thCommon,
    pdpa: thPdpa,
  },
};

// Initialize i18n without LanguageDetector to have full control
i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: localStorage.getItem('i18nextLng') || "th", // Check localStorage first, default to Thai
    fallbackLng: "th", // Fallback to Thai if translation missing
    defaultNS: "common",
    debug: import.meta.env.DEV,

    interpolation: {
      escapeValue: false,
    },

    load: 'languageOnly',
  });

// Save language changes to localStorage
i18n.on('languageChanged', (lng) => {
  localStorage.setItem('i18nextLng', lng);
});

export default i18n;
